import {
  DELETE_ECI_AUTHORISED_PERSON,
  PUT_ECI_AUTHORISED_PERSON,
  GET_ECI_AUTHORISED_PERSONS_LIST,
    POST_ECI_AUTHORISED_PERSON,
  } from "../constants/actionTypes";

  const defaultState = {
    eciAuthorisedPersonsList:[],
  };

  let data = [];
  export default (state = defaultState, action) => {
    try {
      switch (action.type) {
        case GET_ECI_AUTHORISED_PERSONS_LIST:
          return {...state,eciAuthorisedPersonsList:[...action.payload]};
        case POST_ECI_AUTHORISED_PERSON:
          return {...state,eciAuthorisedPersonsList:[...state?.eciAuthorisedPersonsList,action.payload]};
        case PUT_ECI_AUTHORISED_PERSON:
          data = [...state?.eciAuthorisedPersonsList];
          const index = data?.findIndex(
            (setting) => setting?.person_id === action.payload?.person_id,
          );
          if (index != -1) data[index] = { ...action?.payload };
          return {...state,eciAuthorisedPersonsList: [...data]};
        case DELETE_ECI_AUTHORISED_PERSON:
          const updatedArr = [...state?.eciAuthorisedPersonsList].filter(
            (setting) => setting.person_id !== action.payload,
          );
          return {...state,eciAuthorisedPersonsList: [...updatedArr]};
        default:
          return state;
      }
    } catch (error) {
      throw new Error(error);
    }
  };